// visibility.directive.ts
import { Directive, ElementRef, Output, EventEmitter, AfterViewInit, OnDestroy, inject } from '@angular/core';

@Directive({
  selector: '[coinVisibleOnScreen]'
})
export class CoinVisibleOnScreenDirective implements AfterViewInit, OnDestroy {
  private readonly el = inject(ElementRef);

  @Output() isVisible: EventEmitter<boolean> = new EventEmitter();
  private observer: IntersectionObserver;

  ngAfterViewInit(): void {
    this.observer = new IntersectionObserver(entries => {
      const [entry] = entries;
      this.isVisible.emit(entry.isIntersecting);
    });

    this.observer.observe(this.el.nativeElement);
  }

  ngOnDestroy(): void {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}
